'use client';

import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
import type { GenericItem } from '@/client/contentfulClient';

interface GenericContentBlockProps {
  content: GenericItem[];
  onCTAClick: () => Promise<void>;
  isAddingToCart: boolean;
  ctaText?: string;
}

/**
 * @description Matches the GenericContentBlock
 *
 */
export default function GenericContentBlock({
  content,
  onCTAClick,
  isAddingToCart,
  ctaText,
}: GenericContentBlockProps): React.JSX.Element | null {
  const contentBlocks = content?.[0];
  if (!contentBlocks) return null;

  return (
    <div className='flex w-full items-center justify-center px-4 py-14'>
      <div className='flex w-full max-w-screen-lg flex-col items-center justify-center gap-8 md:flex-row md:justify-around'>
        <div className='max-w-1/2 order-1 md:max-w-lg'>
          {contentBlocks.image ? (
            <img
              alt={contentBlocks.image.title ?? 'WHOOP content'}
              className='max-h-64 md:max-h-full'
              data-testid='whats-included-image'
              src={contentBlocks.image.url}
            />
          ) : null}
        </div>
        <div className='order-2 flex flex-col items-center justify-center gap-8 md:items-start'>
          <div className='flex w-full flex-col items-center justify-center gap-7 md:items-start'>
            <h1 className='max-w-52 text-center text-4xl font-semibold md:max-w-md md:pr-6 md:text-start md:text-6xl'>
              {contentBlocks.title}
            </h1>
            <p className='max-w-[400px] px-4 text-center text-base md:px-0 md:text-start'>
              {contentBlocks.description}
            </p>
          </div>
          {ctaText ? (
            <LoadingButton
              className='max-w-[300px] md:max-w-[400px]'
              disabled={isAddingToCart}
              onClick={onCTAClick}
              size='medium'
              variant='primary'
            >
              {ctaText}
            </LoadingButton>
          ) : null}
        </div>
      </div>
    </div>
  );
}
